<!-- 项目案例页面 -->
<template>
  <div class="case-container">
    <!-- Hero Banner -->
    <div class="case-hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-divider"></div>
        <h1 class="hero-title">{{ $t('case.title') }}</h1>
        <p class="hero-sub">{{ $t('case.desc') }}</p>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="main-content-card">

    <!-- Stats Bar -->
    <div class="stats-bar">
      <div class="stats-inner">
        <div class="stat-item" v-for="(s, i) in statsData" :key="i">
          <span class="stat-num">{{ showNum(i) }}</span>
          <span class="stat-label">{{ s.label }}</span>
        </div>
      </div>
    </div>

    <!-- Category Selector -->
    <div class="category-bar-wrapper">
      <!-- Desktop: Collapsible Tabs -->
      <div class="category-bar desktop-only">
        <div
          :class="['category-tab', { active: btn_list === index }]"
          @click="imgqiehuan(index)"
          v-for="(item, index) in lidata.slice(0, collapseCount)"
          :key="'a'+index"
        >
          <span class="tab-dot"></span>
          {{ item }}
        </div>
        <div class="extra-tabs" :class="{ open: showAll }" v-if="lidata.length > collapseCount">
          <div class="extra-tabs-inner">
            <div
              :class="['category-tab', { active: btn_list === (index + collapseCount) }]"
              @click="imgqiehuan(index + collapseCount)"
              v-for="(item, index) in lidata.slice(collapseCount)"
              :key="'b'+index"
            >
              <span class="tab-dot"></span>
              {{ item }}
            </div>
          </div>
        </div>
        <div
          class="category-tab toggle-btn"
          @click="showAll = !showAll"
          v-if="lidata.length > collapseCount"
        >
          <span class="toggle-icon" :class="{ rotated: showAll }">▼</span>
          {{ showAll ? $t('case.collapse') : $t('case.expand') }}
        </div>
      </div>

      <!-- Mobile Picker -->
      <div class="mobile-picker" @click="pickerOpen = !pickerOpen">
        <span class="picker-label">{{ lidata[btn_list] }}</span>
        <span class="picker-arrow" :class="{ up: pickerOpen }">▼</span>
      </div>
      <div class="mobile-picker-list" v-show="pickerOpen">
        <div
          :class="['picker-item', { active: btn_list === index }]"
          @click="selectMobile(index)"
          v-for="(item, index) in lidata"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <!-- Carousel -->
    <div class="carousel-section">
      <div class="carousel-wrapper">
        <el-carousel
          ref="carousel"
          trigger="click"
          height="580px"
          arrow="always"
          :autoplay="!outerVisible"
          @change="onSlideChange"
        >
          <el-carousel-item v-for="(item, i) in lb_data_list" :key="i">
            <div class="carousel-slide">
              <img v-if="btn_list != 8" :src="lb_data_list[i]" alt="" />
              <div class="video-slide" v-if="btn_list == 8">
                <img :src="lb_data_list[i]" alt="" />
                <div class="video-play-btn" @click="openDialog(i)">
                  <img src="../../assets/img/播放.svg" alt="" />
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- Thumbnail Strip -->
    <div class="thumbnail-strip-wrapper" v-if="lb_data_list.length > 1">
      <div class="thumbnail-strip">
        <div
          :class="['thumb-item', { active: activeSlide === i }]"
          @click="goToSlide(i)"
          v-for="(img, i) in lb_data_list"
          :key="i"
        >
          <img :src="img" alt="" />
        </div>
      </div>
    </div>

    <!-- Brand Partners Grid -->
    <div class="brands-section">
      <h3 class="brands-title">{{ $i18n.locale === 'zh' ? '合作品牌' : 'Partner Brands' }}</h3>
      <div class="brands-grid">
        <a
          v-for="(brand, i) in brandLinks"
          :key="i"
          :href="brand.url"
          target="_blank"
          class="brand-item"
          @click="brand.click && brand.click($event)"
        >
          <img :src="brand.img" :alt="brand.alt || ''" />
        </a>
      </div>
    </div>

    </div><!-- /main-content-card -->

    <!-- Video Dialog -->
    <el-dialog @close="closeDialog" :visible.sync="outerVisible" :show-close="false">
      <video ref="videoPlayer" controlsList="nodownload" :src="videoUrl" controls></video>
    </el-dialog>
  </div>
</template>

<script>
import { TweenMax } from 'gsap';

export default {
  computed: {
    lidata() {
      return this.$t('case.categories')
    },
    options() {
      const labels = this.$t('case.options')
      return labels.map((label, i) => ({ value: String(i), label }))
    },
    statsData() {
      return this.$i18n.locale === 'zh' ? [
        { num: '86+', label: '车型用户手册' },
        { num: '64+', label: '车型维修手册' },
        { num: '72+', label: '车型专用工具' },
        { num: '200+', label: '累计服务项目' },
      ] : [
        { num: '86+', label: 'User Manuals' },
        { num: '64+', label: 'Maintenance Manuals' },
        { num: '72+', label: 'Specialty Tools' },
        { num: '200+', label: 'Projects Delivered' },
      ]
    },
    brandLinks() {
      return [
        { url: 'https://forcartech.cn/u-manual/s31-esp/S31-0-1-%E6%A6%82%E8%A7%88-%E5%89%8D%E8%A8%80.html', img: this.$i18n.locale === 'zh' ? require('../../assets/img/东风纳米（西班牙语版）.svg') : require('../../assets/img/东风纳米（西班牙语版）英.svg') },
        { url: 'https://forcartech.cn/u-manual/s31-en/S31-0-1-%E6%A6%82%E8%A7%88-%E5%89%8D%E8%A8%80.html', img: this.$i18n.locale === 'zh' ? require('../../assets/img/东风纳米（英语版）.svg') : require('../../assets/img/东风纳米（英）.svg') },
        { url: 'javascript:void(0)', img: require('../../assets/img/路特斯.svg'), click: (e) => { e.preventDefault(); this.imgqiehuan(11); } },
        { url: 'https://m.dsmp.voyah.com.cn/userguide/h97c/h97c-1.html', img: require('../../assets/img/岚图.svg') },
        { url: 'https://weixin.dfpv.com.cn/dfhome/static/pc.html#/', img: require('../../assets/img/东风风神.svg') },
        { url: 'https://neweinstruction.jmc.com.cn/static/pc.html#/pages/first/first?name=cx743', img: this.$i18n.locale === 'zh' ? require('../../assets/img/福特领睿.svg') : require('../../assets/img/福特.svg') },
        { url: 'https://neweinstruction.jmc.com.cn/static/pc.html#/pages/first/first?name=jp360', img: require('../../assets/img/江铃大道.svg') },
        { url: 'https://forcartech.cn/mzd/j34f/index.html#/', img: this.$i18n.locale === 'zh' ? require('../../assets/img/长安马自达.svg') : require('../../assets/img/长安马自达（英文）.svg') },
      ]
    },
  },
  metaInfo() {
    return {
      title: this.$t('case.seoTitle'),
      meta: [
        { name: "description", content: this.$t('case.seoDescription') },
        { name: "keywords", content: this.$t('case.seoKeywords') },
      ],
    }
  },
  data() {
    return {
      showAll: false,
      pickerOpen: false,
      collapseCount: 6,
      activeSlide: 0,
      outerVisible: false,
      videoUrl: ``,
      mp4: [
        require('@/assets/img/I-spdh/福卡迪-02.极氪cg动画-Lka.mp4'),
        require('@/assets/img/I-spdh/2.北汽激光雷达定位工具.mp4'),
        require('@/assets/img/I-spdh/3.自动紧急制动AEB.mp4'),
        require('@/assets/img/I-spdh/4.车窗初始化.mp4'),
        require('@/assets/img/I-spdh/5.皓极车型电动空调操作指南2.mp4'),
        require('@/assets/img/I-spdh/6.东风风神-自动泊车.mp4'),
        require('@/assets/img/I-spdh/7.岚图free动力电池更换.mp4'),
        require('@/assets/img/I-spdh/8.如何使用智能钥匙打开或关闭车窗.mp4'),
      ],
      btn_list: 0,
      img_datas: [
        { img: [require('@/assets/img/A-sysc/A-使用手册 (1).webp'),require('@/assets/img/A-sysc/A-使用手册 (2).webp'),require('@/assets/img/A-sysc/A-使用手册 (3).webp'),require('@/assets/img/A-sysc/A-使用手册 (4).webp'),require('@/assets/img/A-sysc/A-使用手册 (5).webp'),require('@/assets/img/A-sysc/A-使用手册 (6).webp'),require('@/assets/img/A-sysc/A-使用手册 (7).webp'),require('@/assets/img/A-sysc/A-使用手册 (8).webp'),require('@/assets/img/A-sysc/A-使用手册 (10).webp')] },
        { img: [require('@/assets/img/B-wxsc/B-维修手册 (1).webp'),require('@/assets/img/B-wxsc/B-维修手册 (2).webp'),require('@/assets/img/B-wxsc/B-维修手册 (3).webp'),require('@/assets/img/B-wxsc/B-维修手册 (4).webp'),require('@/assets/img/B-wxsc/B-维修手册 (5).webp'),require('@/assets/img/B-wxsc/B-维修手册 (6).webp'),require('@/assets/img/B-wxsc/B-维修手册 (7).webp')] },
        { img: [require('@/assets/img/C-bjml/C-备件目录 (1).webp'),require('@/assets/img/C-bjml/C-备件目录 (2).webp'),require('@/assets/img/C-bjml/C-备件目录 (3).webp'),require('@/assets/img/C-bjml/C-备件目录 (4).webp'),require('@/assets/img/C-bjml/C-备件目录 (5).webp'),require('@/assets/img/C-bjml/C-备件目录 (6).webp')] },
        { img: [require('@/assets/img/D-dlt/D-电路图 (1).webp'),require('@/assets/img/D-dlt/D-电路图 (2).webp'),require('@/assets/img/D-dlt/D-电路图 (3).webp'),require('@/assets/img/D-dlt/D-电路图 (4).webp'),require('@/assets/img/D-dlt/D-电路图 (5).webp'),require('@/assets/img/D-dlt/D-电路图 (6).webp'),require('@/assets/img/D-dlt/D-电路图 (7).webp'),require('@/assets/img/D-dlt/D-电路图 (8).webp'),require('@/assets/img/D-dlt/D-电路图 (9).webp'),require('@/assets/img/D-dlt/D-电路图 (10).webp')] },
        { img: [require('@/assets/img/E-cjsc/E-拆解手册 (1).webp'),require('@/assets/img/E-cjsc/E-拆解手册 (2).webp'),require('@/assets/img/E-cjsc/E-拆解手册 (3).webp'),require('@/assets/img/E-cjsc/E-拆解手册 (4).webp'),require('@/assets/img/E-cjsc/E-拆解手册 (5).webp'),require('@/assets/img/E-cjsc/E-拆解手册 (6).webp')] },
        { img: [require('@/assets/img/F-gssc/F-工时手册 (1).webp'),require('@/assets/img/F-gssc/F-工时手册 (2).webp'),require('@/assets/img/F-gssc/F-工时手册 (3).webp'),require('@/assets/img/F-gssc/F-工时手册 (4).webp'),require('@/assets/img/F-gssc/F-工时手册 (5).webp'),require('@/assets/img/F-gssc/F-工时手册 (6).webp')] },
        { img: [require('@/assets/img/G-zygj/G-专用工具 (1).webp'),require('@/assets/img/G-zygj/G-专用工具 (2).webp'),require('@/assets/img/G-zygj/G-专用工具 (3).webp'),require('@/assets/img/G-zygj/G-专用工具 (4).webp'),require('@/assets/img/G-zygj/G-专用工具 (5).webp'),require('@/assets/img/G-zygj/G-专用工具 (6).webp'),require('@/assets/img/G-zygj/G-专用工具 (7).webp'),require('@/assets/img/G-zygj/G-专用工具 (10).webp'),require('@/assets/img/G-zygj/G-专用工具 (11).webp'),require('@/assets/img/G-zygj/G-专用工具 (12).webp'),require('@/assets/img/G-zygj/G-专用工具 (13).webp'),require('@/assets/img/G-zygj/G-专用工具 (14).webp'),require('@/assets/img/G-zygj/G-专用工具 (15).webp'),require('@/assets/img/G-zygj/G-专用工具 (16).webp')] },
        { img: [require('@/assets/img/H-pxjj/H-培训教材教具 (1).webp'),require('@/assets/img/H-pxjj/H-培训教材教具 (2).webp'),require('@/assets/img/H-pxjj/H-培训教材教具 (3).webp'),require('@/assets/img/H-pxjj/H-培训教材教具 (4).webp'),require('@/assets/img/H-pxjj/H-培训教材教具 (5).webp'),require('@/assets/img/H-pxjj/H-培训教材教具 (6).webp')] },
        { img: [require('@/assets/img/I-spdh/1.极氪CG动画-LKA.webp'),require('@/assets/img/I-spdh/2.北汽激光雷达定位工具.webp'),require('@/assets/img/I-spdh/3.自动紧急制动AEB.webp'),require('@/assets/img/I-spdh/4.车窗初始化.webp'),require('@/assets/img/I-spdh/5.皓极车型电动空调操作指南2.webp'),require('@/assets/img/I-spdh/6.东风风神-自动泊车.webp'),require('@/assets/img/I-spdh/7.岚图free动力电池更换.webp'),require('@/assets/img/I-spdh/8.如何使用智能钥匙打开或关闭车窗.webp')] },
        { img: [require('@/assets/img/J-rjxt/J-软件系统 (1).webp'),require('@/assets/img/J-rjxt/J-软件系统 (2).webp'),require('@/assets/img/J-rjxt/J-软件系统 (3).webp'),require('@/assets/img/J-rjxt/J-软件系统 (4).webp'),require('@/assets/img/J-rjxt/J-软件系统 (5).webp'),require('@/assets/img/J-rjxt/J-软件系统 (6).webp'),require('@/assets/img/J-rjxt/J-软件系统 (7).webp'),require('@/assets/img/J-rjxt/J-软件系统 (8).webp'),require('@/assets/img/J-rjxt/J-软件系统 (9).webp'),require('@/assets/img/J-rjxt/J-软件系统 (10).webp'),require('@/assets/img/J-rjxt/J-软件系统 (11).webp'),require('@/assets/img/J-rjxt/J-软件系统 (12).webp'),require('@/assets/img/J-rjxt/J-软件系统 (13).webp')] },
        { img: [require('@/assets/img/K-qt/随车资料袋.webp'),require('@/assets/img/K-qt/与武汉科技大学合作支持2014.2015.2016年中国大学生方程式汽车大赛.webp')] },
        { img: [require('@/assets/img/L-ltsbj/L-ltsbj（1）.jpg'),require('@/assets/img/L-ltsbj/L-ltsbj（2）.jpg'),require('@/assets/img/L-ltsbj/L-ltsbj（3）.jpg'),require('@/assets/img/L-ltsbj/L-ltsbj（4）.jpg'),require('@/assets/img/L-ltsbj/L-ltsbj（5）.jpg'),require('@/assets/img/L-ltsbj/L-ltsbj（6）.png'),require('@/assets/img/L-ltsbj/L-ltsbj（7）.png'),require('@/assets/img/L-ltsbj/L-ltsbj（8）.png')] },
      ],
      lb_data_list: [],
      animatedNums: [0, 0, 0, 0],
    };
  },
  created() {
    if (this.$route.query.id) {
      this.btn_list = Number(this.$route.query.id);
      this.imgqiehuan(this.btn_list);
    } else {
      this.lb_data_list = this.img_datas[0].img;
    }
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
    this.$nextTick(() => { this.animateStats(); });
  },
  watch: {
    '$i18n.locale'() {
      this.animatedNums = [0, 0, 0, 0];
      this.$nextTick(() => { this.animateStats(); });
    },
  },
  methods: {
    showNum(i) {
      const target = this.statsData[i];
      if (!target) return '';
      // Strip the numeric part and keep the suffix (e.g. "86+" → num=86, suffix="+")
      const match = target.num.match(/^(\d+)(.*)$/);
      if (!match) return this.animatedNums[i] || target.num;
      const suffix = match[2];
      const current = this.animatedNums[i];
      if (current === undefined) return target.num;
      return current + suffix;
    },
    animateStats() {
      const targets = this.statsData.map(s => {
        const m = s.num.match(/^(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      });
      const duration = 1600; // ms
      const startTime = performance.now();

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // Ease-out quad
        const eased = 1 - (1 - progress) * (1 - progress);

        targets.forEach((target, i) => {
          const val = Math.round(target * eased);
          this.$set(this.animatedNums, i, val);
        });

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    },
    imgqiehuan(index) {
      this.btn_list = index;
      this.lb_data_list = this.img_datas[index].img;
      this.activeSlide = 0;
      TweenMax.fromTo(".el-carousel__item", 0.6, { opacity: 0 }, { opacity: 1 });
    },
    selectMobile(index) {
      this.imgqiehuan(index);
      this.pickerOpen = false;
      this.activeSlide = 0;
    },
    onSlideChange(index) {
      this.activeSlide = index;
    },
    goToSlide(index) {
      this.$refs.carousel && this.$refs.carousel.setActiveItem(index);
      this.activeSlide = index;
    },
    openDialog(index) {
      this.outerVisible = true;
      this.videoUrl = this.mp4[index];
      // iOS Safari requires play() within the same user gesture tick
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.play().catch(() => {}); // ignore autoplay errors
        }
      });
    },
    closeDialog() {
      this.outerVisible = false;
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.case-container {
  width: 100%;
  min-width: auto;
  max-width: 100vw;
  overflow-x: hidden;
  background: linear-gradient(180deg, #eef0f5 0%, #f8f9fc 30%, #f8f9fc 100%);

  // ========== Hero Banner ==========
  .case-hero {
    position: relative;
    width: 100%;
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 40%, #0f3460 100%);
    overflow: hidden;

    @media (max-width: 768px) { min-height: 220px; }
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 20% 50%, rgba(213,52,52,0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 50%, rgba(213,52,52,0.06) 0%, transparent 50%);
    pointer-events: none;
  }

  .hero-content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 60px 20px;
    max-width: 800px;
    @media (max-width: 768px) { padding: 40px 20px; }
  }

  .hero-divider {
    width: 50px; height: 3px;
    background: #d53434;
    margin: 0 auto 24px;
    border-radius: 2px;
    @media (max-width: 768px) { width: 36px; margin-bottom: 18px; }
  }

  .hero-title {
    font-size: 38px; color: #fff; font-weight: 700;
    line-height: 1.5; margin: 0 0 16px; letter-spacing: 2px;
    .lang-en & { font-size: 28px; letter-spacing: 1px; }
    @media (max-width: 768px) { font-size: 24px; letter-spacing: 1px; .lang-en & { font-size: 18px; } }
  }

  .hero-sub {
    font-size: 17px; color: rgba(255,255,255,0.65); margin: 0 auto;
    line-height: 1.8; max-width: 600px;
    .lang-en & { font-size: 14px; }
    @media (max-width: 768px) { font-size: 14px; .lang-en & { font-size: 12px; } }
  }

  // ========== Main Content Card ==========
  .main-content-card {
    max-width: 1200px; width: 100%;
    margin: -40px auto 60px; padding: 20px 0 30px;
    background: #fff; border-radius: 20px;
    box-shadow: 0 2px 30px rgba(0,0,0,0.05);
    position: relative; z-index: 2;
    overflow-x: hidden;
    @media (max-width: 768px) { margin: -24px 12px 40px; width: calc(100% - 24px); padding: 52px 0 20px; border-radius: 14px; }
  }

  // ========== Stats Bar ==========
  .stats-bar {
    max-width: 1150px; width: 100%; padding: 0 20px; margin: 32px auto 0;
    @media (max-width: 768px) { margin: 20px auto 16px; padding: 0 12px; }
  }
  .stats-inner {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px;
    @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  }
  .stat-item {
    background: #fafbfc; border: 1px solid #eef0f3; border-radius: 12px;
    padding: 20px 16px; text-align: center;
    box-shadow: 0 1px 6px rgba(0,0,0,0.04);
    transition: transform 0.2s, box-shadow 0.2s;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
    @media (max-width: 768px) { padding: 14px 10px; }
  }
  .stat-num {
    display: block; font-size: 32px; font-weight: 800; color: #d53434; line-height: 1.2;
    .lang-en & { font-size: 28px; }
    @media (max-width: 768px) { font-size: 24px; .lang-en & { font-size: 22px; } }
  }
  .stat-label {
    display: block; font-size: 13px; color: #888; margin-top: 6px;
    .lang-en & { font-size: 11px; }
    @media (max-width: 768px) { font-size: 12px; }
  }

  // ========== Category Bar ==========
  .category-bar-wrapper {
    max-width: 1150px; width: 100%; padding: 0 20px;
    margin: 30px auto 20px; position: relative;
    @media (max-width: 768px) {
      margin: 0; padding: 0;
      position: fixed; top: 50px; left: 0; right: 0; z-index: 20;
      background: rgba(248,249,252,0.95);
      padding: 8px 16px;

      // Use a pseudo-element for backdrop-filter to prevent iOS Safari
      // from creating a GPU compositor layer that blocks child touch events.
      &::before {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        z-index: -1;
      }
    }
  }
  .category-bar {
    display: flex; flex-wrap: wrap; gap: 10px; justify-content: center;
  }
  .desktop-only {
    @media (max-width: 768px) { display: none; }
  }
  .category-tab {
    display: flex; align-items: center; gap: 6px;
    padding: 10px 18px;
    background: #f5f6f8; border: 1px solid #e8eaef;
    border-radius: 30px; font-size: 14px; color: #555;
    cursor: pointer; white-space: nowrap;
    transition: all 0.25s; user-select: none;
    .lang-en & { font-size: 12px; padding: 9px 14px; }
    &:hover { color: #d53434; border-color: #fcc; background: #fef5f5; }
    &.active {
      background: linear-gradient(135deg, #d53434, #c01c1c);
      color: #fff; border-color: transparent;
      box-shadow: 0 4px 16px rgba(213,52,52,0.3);
      .tab-dot { background: #fff; }
    }
    @media (max-width: 768px) { font-size: 13px; padding: 8px 14px; flex-shrink: 0; }
  }
  .tab-dot { width: 6px; height: 6px; border-radius: 50%; background: #d53434; flex-shrink: 0; }
  .toggle-btn {
    background: transparent; border: none; color: #d53434;
    padding: 10px 6px; font-size: 14px; gap: 4px; box-shadow: none; cursor: pointer;
    &:hover { color: #ff4444; background: transparent; }
    .toggle-icon { font-size: 10px; transition: transform 0.35s ease; display: inline-block;
      &.rotated { transform: rotate(180deg); }
    }
  }
  .extra-tabs {
    max-height: 0; overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0.4, 0, 0.2, 1); width: 100%;
    &.open { max-height: 300px; }
  }
  .extra-tabs-inner { display: flex; flex-wrap: wrap; gap: 10px; padding-top: 10px; justify-content: center; }

  // ========== Mobile Picker ==========
  .mobile-picker {
    display: none;
    @media (max-width: 768px) {
      display: flex; align-items: center; justify-content: space-between;
      padding: 12px 16px;
      background: #f5f6f8; border: 1px solid #e0e3e8;
      border-radius: 12px; cursor: pointer; font-size: 15px; color: #333; user-select: none;
    }
    .picker-arrow { font-size: 10px; color: #999; transition: transform 0.25s; &.up { transform: rotate(180deg); } }
  }
  .mobile-picker-list {
    display: none;
    @media (max-width: 768px) {
      display: block; position: absolute; top: 100%;
      left: 16px; right: 16px; z-index: 10; margin-top: 2px;
      background: #fff; border-radius: 12px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.15);
      overflow: hidden; max-height: 60vh; overflow-y: auto;
    }
  }
  .picker-item {
    padding: 12px 16px; font-size: 14px; color: #555;
    cursor: pointer; border-bottom: 1px solid #f0f0f0; transition: background 0.15s;
    &:last-child { border-bottom: none; }
    &:hover { background: #fef0f0; }
    &.active { color: #d53434; background: #fef5f5; font-weight: 600; }
  }

  // ========== Carousel ==========
  .carousel-section {
    max-width: 1150px; width: 100%; padding: 0 20px; margin: 0 auto 20px;
    @media (max-width: 768px) { padding: 0 12px; margin-bottom: 16px; }
  }
  .carousel-wrapper {
    border-radius: 16px; overflow: hidden;
    box-shadow: 0 4px 30px rgba(0,0,0,0.08);
    @media (max-width: 768px) { border-radius: 0; }
  }
  .carousel-slide {
    width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
    background: #f0f0f0; border-radius: 16px; overflow: hidden;
    @media (max-width: 768px) { border-radius: 0; }
    img { width: 100%; height: 100%; object-fit: cover; border-radius: 16px;
      @media (max-width: 768px) { border-radius: 0; } }
  }
  .video-slide {
    position: relative; width: 100%; height: 100%;
    display: flex; align-items: center; justify-content: center;
    background: #000; border-radius: 16px; overflow: hidden;
    @media (max-width: 768px) { border-radius: 0; }
    img { width: 100%; height: 100%; object-fit: cover; opacity: 0.85; }
  }
  .video-play-btn {
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    cursor: pointer; transition: transform 0.2s;
    &:hover { transform: translate(-50%, -50%) scale(1.1); }
    img { width: 72px; height: auto; opacity: 1; @media (max-width: 768px) { width: 52px; } }
  }

  // ========== Thumbnail Strip ==========
  .thumbnail-strip-wrapper {
    max-width: 1150px; width: 100%; padding: 0 20px; margin: 16px auto 0; position: relative;
    &::after {
      content: ''; position: absolute; right: 20px; top: 0; bottom: 0; width: 40px;
      background: linear-gradient(90deg, transparent, #fff); pointer-events: none; z-index: 2;
      @media (max-width: 768px) { right: 16px; width: 30px; }
    }
    @media (max-width: 768px) { margin: 10px auto 0; padding: 0 16px; }
  }
  .thumbnail-strip {
    display: flex; gap: 10px; overflow-x: auto; padding: 2px 4px 6px;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar { height: 0; }
    &::after { content: ''; flex-shrink: 0; width: 1px; }
    @media (max-width: 768px) { gap: 8px; padding: 2px 2px 6px; }
  }
  .thumb-item {
    flex-shrink: 0; width: 100px; height: 68px;
    border-radius: 8px; overflow: hidden; cursor: pointer;
    border: 2px solid #e0e3e8; opacity: 0.7; background: #f0f0f0;
    transition: all 0.25s;
    &:hover { opacity: 1; border-color: #ccc; }
    &.active { border-color: #d53434; opacity: 1; box-shadow: 0 2px 12px rgba(213,52,52,0.25); }
    img { width: 100%; height: 100%; object-fit: cover; }
    @media (max-width: 900px) { width: 82px; height: 56px; }
    @media (max-width: 768px) { width: 68px; height: 48px; }
  }

  // ========== Brand Partners ==========
  .brands-section {
    max-width: 1150px; width: 100%; padding: 0 20px 30px; margin: 0 auto;
    @media (max-width: 768px) { padding: 0 16px 60px; }
  }
  .brands-title {
    text-align: center; font-size: 22px; color: #1a1a1a; margin: 0 0 28px;
    @media (max-width: 768px) { font-size: 18px; margin-bottom: 20px; }
  }
  .brands-grid {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px;
    @media (max-width: 900px) { grid-template-columns: repeat(3, 1fr); gap: 12px; }
    @media (max-width: 500px) { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  }
  .brand-item {
    background: #fff; border: 1px solid #eef0f3; border-radius: 12px;
    padding: 12px; display: flex; align-items: center; justify-content: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.03);
    transition: transform 0.25s, box-shadow 0.25s; text-decoration: none; aspect-ratio: 3 / 1;
    min-width: 0; overflow: hidden;
    &:hover { transform: translateY(-3px); box-shadow: 0 8px 30px rgba(0,0,0,0.1); }
    img { width: 100%; height: 100%; object-fit: contain; max-width: 100%; }
    @media (max-width: 768px) { padding: 10px; }
  }
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button { background-color: #d2d2d2; width: 20px; height: 4px; border-radius: 20px; @media (max-width: 768px) { width: 7px; height: 7px; border-radius: 7px; } }
::v-deep .is-active .el-carousel__button { background-color: #d53434; width: 32px; border-radius: 20px; @media (max-width: 768px) { width: 7px; height: 7px; border-radius: 7px; } }
::v-deep .el-carousel__container { height: 580px !important; border-radius: 16px; @media (max-width: 1200px) { height: 420px !important; } @media (max-width: 768px) { height: 260px !important; border-radius: 0; } }
::v-deep .el-carousel__item { border-radius: 16px; overflow: hidden; @media (max-width: 768px) { border-radius: 0; } }
::v-deep .el-dialog { max-width: 1350px; width: 70% !important; margin-top: 5vh !important; @media (max-width: 768px) { width: 95% !important; margin: 0 !important; } }
::v-deep .el-dialog__body { @media (max-width: 768px) { padding: 0; } }
::v-deep .el-dialog video { width: 100%; @media (max-width: 768px) { margin-top: 180px; } }
</style>
